<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5178 5.40924C16.1077 4.6954 16.5378 3.69848 16.5378 2.70157C16.5378 2.56617 16.5255 2.43077 16.5009 2.32001C15.5301 2.35693 14.3627 2.97229 13.6622 3.79696C13.1091 4.42468 12.6053 5.40924 12.6053 6.41852C12.6053 6.5662 12.6299 6.71388 12.6422 6.76316C12.7272 6.7793 12.8136 6.78749 12.9002 6.78779C13.7728 6.78764 14.8665 6.19692 15.5178 5.40924ZM16.206 6.99688C14.7436 6.99688 13.5516 7.88304 12.802 7.88304C11.9909 7.88304 10.9217 7.04608 9.65594 7.04608C7.24728 7.04608 4.80176 9.03992 4.80176 12.8061C4.80176 15.1445 5.71117 17.6184 6.82944 19.2184C7.78798 20.5723 8.62367 21.68 9.82799 21.68C11.0201 21.68 11.5485 20.88 13.0354 20.88C14.547 20.88 14.8788 21.6554 16.206 21.6554C17.5087 21.6554 18.3811 20.4492 19.2046 19.2676C20.1263 17.9138 20.5072 16.5846 20.5318 16.523C20.4458 16.4984 17.951 15.4769 17.951 12.6092C17.951 10.123 19.9173 9.003 20.0279 8.91688C18.7253 7.04616 16.7467 6.99688 16.206 6.99688Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "AppleIcon",
  props: {
    color: {
      type: String,
      default: "black"
    }
  }
};
</script>
